import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import services1 from '../../photos/services1.jpg';
import services2 from '../../photos/services2.jpg';
import services3 from '../../photos/services3.jpg';
import services4 from '../../photos/services4.jpg';
import services5 from '../../photos/services5.jpg';
import services6 from '../../photos/services6.jpg';

const services = [
  {
    img: services1,
    title: 'Фура',
    desc: 'Перевезення тентами 20-22 тонн. Доставка будь-яких вантажів по Україні та за кордон. Повний комплект документів, GPS-відстеження маршруту.',
  },
  {
    img: services2,
    title: 'Цистерна',
    desc: 'Перевезення наливних вантажів: паливо, рослинні олії, хімічна продукція. Сертифіковані цистерни з дотриманням усіх норм безпеки.',
  },
  {
    img: services3,
    title: 'Зерновоз',
    desc: 'Перевезення зернових культур Україна-порт. Зерновози великого об\'єму, оперативна подача під завантаження, контроль ваги.',
  },
  {
    img: services4,
    title: 'Самоскид',
    desc: 'Перевезення сипучих вантажів та будматеріалів. Пісок, щебінь, ґрунт - доставка на будмайданчик точно в строк.',
  },
  {
    img: services5,
    title: 'Кінь',
    desc: 'Працюємо як коні! Наша команда дійсно працює без зупинок - 24/7, без вихідних, щоб ваш вантаж був доставлений вчасно.',
  },
  {
    img: services6,
    title: 'Рефрижератор',
    desc: 'Перевезення продуктів харчування з дотриманням температурного режиму. Контроль температури протягом усього маршруту.',
  },
];

function ProductCategories() {
  const sectionRef = useRef(null);
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.service-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0) scale(1)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (activeCard !== null) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [activeCard]);

  return (
    <>
    <section ref={sectionRef} style={{
      padding: '120px 24px',
      background: 'linear-gradient(180deg, #0a0a0f 0%, #0d1a0e 100%)',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 16,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Наші <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>послуги</span>
        </h2>
        <p style={{
          textAlign: 'center',
          color: 'rgba(255,255,255,0.5)',
          fontSize: 16,
          marginBottom: 60,
          maxWidth: 500,
          margin: '0 auto 60px',
        }}>
          Перевезення будь-яким типом транспорту по Україні та за кордон
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 16,
        }}>
          {services.map((service, i) => (
            <div key={i} className="service-card" style={{
              opacity: 0,
              transform: 'translateY(30px) scale(0.95)',
              transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              borderRadius: 16,
              overflow: 'hidden',
              aspectRatio: '4/3',
              cursor: 'pointer',
            }}
            onClick={() => setActiveCard(i)}
            onMouseOver={e => {
              const img = e.currentTarget.querySelector('img');
              const overlay = e.currentTarget.querySelector('.overlay');
              if (img) img.style.transform = 'scale(1.1)';
              if (overlay) overlay.style.background = 'linear-gradient(0deg, rgba(22,183,36,0.6) 0%, rgba(0,0,0,0.2) 100%)';
            }}
            onMouseOut={e => {
              const img = e.currentTarget.querySelector('img');
              const overlay = e.currentTarget.querySelector('.overlay');
              if (img) img.style.transform = 'scale(1)';
              if (overlay) overlay.style.background = 'linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.1) 100%)';
            }}
            >
              <img src={service.img} alt={service.title} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'transform 0.6s ease',
              }} />
              <div className="overlay" style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.1) 100%)',
                transition: 'background 0.4s ease',
                display: 'flex',
                alignItems: 'flex-end',
                padding: 24,
              }}>
                <span style={{
                  fontSize: 'clamp(16px, 2vw, 22px)',
                  fontWeight: 600,
                  color: '#fff',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                }}>
                  {service.title}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          section > div > div:last-child {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 480px) {
          section > div > div:last-child {
            grid-template-columns: 1fr !important;
          }
        }
        @keyframes serviceModalIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes serviceCardIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </section>

    {/* Service Modal */}
    {activeCard !== null && ReactDOM.createPortal(
      <div
        onClick={() => setActiveCard(null)}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10000,
          background: 'rgba(0,0,0,0.85)',
          backdropFilter: 'blur(12px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          animation: 'serviceModalIn 0.3s ease',
        }}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            background: 'linear-gradient(180deg, #111518 0%, #0a0f0a 100%)',
            border: '1px solid rgba(77,194,71,0.15)',
            borderRadius: 24,
            maxWidth: 550,
            width: '100%',
            overflow: 'hidden',
            animation: 'serviceCardIn 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <div style={{
            height: 250,
            overflow: 'hidden',
            position: 'relative',
          }}>
            <img src={services[activeCard].img} alt="" style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }} />
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(0deg, #111518 0%, transparent 60%)',
            }} />
            <button
              onClick={() => setActiveCard(null)}
              style={{
                position: 'absolute',
                top: 16,
                right: 16,
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'rgba(0,0,0,0.5)',
                backdropFilter: 'blur(8px)',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#fff',
                fontSize: 20,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              ✕
            </button>
          </div>
          <div style={{ padding: '20px 32px 32px' }}>
            <h3 style={{
              fontSize: 28,
              fontWeight: 700,
              color: '#fff',
              textTransform: 'uppercase',
              marginBottom: 16,
            }}>
              {services[activeCard].title}
            </h3>
            <p style={{
              fontSize: 15,
              color: 'rgba(255,255,255,0.7)',
              lineHeight: 1.8,
            }}>
              {services[activeCard].desc}
            </p>
          </div>
        </div>
      </div>,
      document.body
    )}
    </>
  );
}

export default ProductCategories;
